document.addEventListener("DOMContentLoaded", async () => {
  const headers = {
    apikey: "68c98006-4e46-4b8b-8387-685036c84f43",
    country: "TURKEY",
  };
  const scriptElement = document.querySelector("#ft-dropdown-v3-script");
  const jsonDataUrl = scriptElement.dataset.jsonLink;
  const marketData = await fetch(jsonDataUrl).then(async (res) => {
    return await res.json();
  });
  const brandSelectBox = document.querySelector("#brandSelection");
  const modelSelectBox = document.querySelector("#modelSelection");
  const yearSelectBox = document.querySelector("#yearSelection");
  const engineSelectBox = document.querySelector("#engineSelection");
  let productContainer = document.getElementById("productContainer");

  handleBrands();

  let product = null;

  const carInfo = {
    brand: "",
    model: "",
    year: "",
    engine: "",
  };

  async function handleBrands() {
    loadingIconState(brandSelectBox, "show");
    const makes = marketData.map((item) => item.make);
    addOptions(brandSelectBox, makes);
    loadingIconState(brandSelectBox, "hide");
    enableSelectBox(brandSelectBox);
  }

  async function fetchModels(make) {
    const makeItem = marketData.find((item) => item.make === make);
    if (!makeItem) throw new Error("can not find make");
    const models = makeItem.models.map((item) => item.model);
    addOptions(modelSelectBox, models);
  }

  async function fetchYears(make, model) {
    const foundMake = marketData.find((item) => item.make === make);
    if (!foundMake) throw new Error("can not find make");
    const foundModel = foundMake.models.find((item) => item.model === model);
    if (!foundModel) throw new Error("can not find model");
    const data = [
      ...new Set(foundModel.variants.map((variant) => variant.body)),
    ];

    addOptions(yearSelectBox, data);
  }

  async function fetchEngines(make, model, year) {
    const foundMake = marketData.find((item) => item.make === make);
    if (!foundMake) throw new Error("can not find make");
    const foundModel = foundMake.models.find((item) => item.model === model);
    if (!foundModel) throw new Error("can not find model");
    const foundYears = foundModel.variants.filter(
      (variant) => variant.body === year
    );
    if (!foundYears || foundYears.length === 0)
      throw new Error("can not find years");
    const engineVolumes = foundYears
      .map((item) => item["engine-volume"])
      .join(" - ")
      .split(" - ")
      .map((item) => item.trim())
      .sort();
    addOptions(engineSelectBox, engineVolumes);
  }

  async function fetchProductCode(make, model, year, engine) {
    const foundMake = marketData.find((item) => item.make === make);
    if (!foundMake) throw new Error("can not find make");
    const foundModel = foundMake.models.find((item) => item.model === model);
    if (!foundModel) throw new Error("can not find model");
    const foundYears = foundModel.variants.filter(
      (variant) => variant.body === year
    );
    if (!foundYears || foundYears.length === 0)
      throw new Error("can not find years");
    const foundYear = foundYears.find((item) => {
      return item["engine-volume"]
        .split(" - ")
        .map((item) => item.trim())
        .includes(engine);
    });
    if (!foundYear) throw new Error(`can not find year`);
    const socketRaw = foundYear.socket;
    console.log(socketRaw);
    if (socketRaw.includes("PC")) {
      const socketNumber = foundYear.socket
        .split("PC")
        .filter((item) => item)[0];
      product = "PC " + socketNumber;
    } else {
      product = socketRaw;
    }
  }

  function addOptions(el, data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] == "Can-Am" || data[i] == "Polaris") {
        continue;
      }
      let option = document.createElement("option");
      option.textContent = data[i];
      option.value = data[i];
      el.appendChild(option);
    }
  }

  function clearOptions(selectEl, placeholderText, prop) {
    selectEl.innerHTML = "";
    carInfo[prop] = "";
    const defaultOption = document.createElement("option");
    defaultOption.textContent = placeholderText;
    defaultOption.disabled = true;
    defaultOption.selected = true;
    defaultOption.hidden = true;
    selectEl.append(defaultOption);
  }

  function listenForBrandSelection() {
    brandSelectBox.addEventListener("change", function (e) {
      loadingIconState(modelSelectBox, "show");
      carInfo["brand"] = e.target.value;
      updateBreadcrumbs("brand", carInfo.brand);

      clearOptions(modelSelectBox, "Aracınızın Modelini Seçin", "model");
      clearOptions(yearSelectBox, "Aracınızın Kasasını Seçin", "year");
      clearOptions(engineSelectBox, "Aracınızın Motorunu Seçin", "engine");
      fetchModels(carInfo.brand).then(() => {
        animatePreviousBox(brandSelectBox);
        modelSelectBox.closest(".column").classList.remove("is-hidden");

        // displayParentBox(modelSelectBox);

        loadingIconState(modelSelectBox, "hide");

        enableSelectBox(modelSelectBox);
        disableSelectBox(yearSelectBox, engineSelectBox);
      });
    });
  }

  function listenForModelSelection() {
    modelSelectBox.addEventListener("change", (e) => {
      loadingIconState(yearSelectBox, "show");
      carInfo["model"] = e.target.value;
      updateBreadcrumbs("model", carInfo.model);
      clearOptions(yearSelectBox, "Aracınızın Kasasını Seçin", "year");
      clearOptions(engineSelectBox, "Aracınızın Motorunu Seçin", "engine");
      fetchYears(carInfo.brand, carInfo.model).then(() => {
        animatePreviousBox(modelSelectBox);
        yearSelectBox.closest(".column").classList.remove("is-hidden");

        loadingIconState(yearSelectBox, "hide");
        // hideLoadingIcon(yearSelectBox);
        enableSelectBox(yearSelectBox);
        disableSelectBox(engineSelectBox);
      });
    });
  }

  function listenForYearSelection() {
    yearSelectBox.addEventListener("change", (e) => {
      loadingIconState(engineSelectBox, "show");
      carInfo["year"] = e.target.value;
      updateBreadcrumbs("year", carInfo.year);
      clearOptions(engineSelectBox, "Aracınızın Motorunu Seçin", "engine");
      fetchEngines(carInfo.brand, carInfo.model, carInfo.year).then(() => {
        animatePreviousBox(yearSelectBox);
        engineSelectBox.closest(".column").classList.remove("is-hidden");
        loadingIconState(engineSelectBox, "hide");
        enableSelectBox(engineSelectBox);
      });
    });
  }

  function listenForEngineSelection() {
    engineSelectBox.addEventListener("change", (e) => {
      loadingIconState(engineSelectBox, "show");
      carInfo["engine"] = e.target.value;

      fetchProductCode(
        carInfo.brand,
        carInfo.model,
        carInfo.year,
        carInfo.engine
      ).then(() => {
        loadingIconState(engineSelectBox, "hide");
        product = product.toString().toLowerCase().replace(" ", "");
        updateBreadcrumbs("engine", carInfo.engine);
        engineSelectBox.closest("section").style.display = "none";
        document.querySelector(".breadcrumbs-section").style.display = "none";

        finalFetchProduct(`/products/${product}.js`);
      });
      if (window.innerWidth < 768) {
        window.scrollTo({
          top: 390,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 640,
          behavior: "smooth",
        });
      }
    });
  }

  listenForBrandSelection();
  listenForModelSelection();
  listenForYearSelection();
  listenForEngineSelection();

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  async function finalFetchProduct(url) {
    const res = await fetch(url, {
      mode: "cors",
    });
    const data = await res.json();
    let { id, title, available, compare_at_price, price, featured_image } =
      data;
    id = data.variants[0].id;
    price = `${fixCurrency(price)}₺`;
    compare_at_price = `10.950,00₺`;

    renderProductContainer(title, compare_at_price, price);

    // stickyAddToCart(title, price, compare_at_price, featured_image);

    let addToCartBtn = document.getElementById("addToCartBtn");
    // let stickyAddToCartBtn = document.getElementById("stickyAddToCartBtn");
    // let resetBtnSticky = document.getElementById("rstBtn");

    let checkoutBtn = document.getElementById("checkoutBtn");
    addToCartBtn.dataset.pid = id;
    addToCartBtn.addEventListener("click", handleCartAdd);
    // stickyAddToCartBtn.addEventListener("click", handleCartAdd);
    // resetBtnSticky.addEventListener("click", clearDropdownFields);

    checkoutBtn.addEventListener("click", handleCartAdd);
  }

  function handleResetButtons() {
    let resetBtnMain = document.getElementById("resetBtnMain");
    resetBtnMain.addEventListener("click", clearDropdownFields);

    let selectAnotherVehicle = document.getElementById("selectAnotherVehicle");
    selectAnotherVehicle.addEventListener("click", clearDropdownFields);
  }

  handleResetButtons();

  function handleCartAdd(el) {
    let selectedElementId = el.currentTarget.id;
    let addToCartBtn = document.getElementById("addToCartBtn");
    let productId = addToCartBtn.dataset.pid;
    let cart = new theme.CartDrawer();
    let formData = {
      items: [
        {
          id: productId,
          quantity: 1,
          properties: {
            Aracınız: `${carInfo.brand} / ${carInfo.model} / ${carInfo.year} / ${carInfo.engine}`,
          },
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then(() => {
        if (
          selectedElementId == "addToCartBtn" ||
          selectedElementId == "stickyAddToCartBtn"
        ) {
          cart.init();
          cart.open();
        } else {
          window.location.href = "/checkout";
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function renderProductContainer(title, compare_at_price, price) {
    let paymentContainer = document.querySelector(".payment-btns-wrapper");
    // let pPayment = document.querySelector(".p-payment");

    function setProductInfo() {
      let productTitle = document.getElementById("productTitle");
      productTitle.textContent = title;
      let vehicleDetails = document.getElementById("vehicleDetails");
      vehicleDetails.textContent = `${carInfo.brand} / ${carInfo.model} / ${carInfo.year} / ${carInfo.engine}`;
      let productPrice = document.getElementById("productPrice");
      productPrice.textContent = price;
      // let productCompareAtPrice = document.getElementById(
      ("productCompareAtPrice");
      //);
      // productCompareAtPrice.textContent = `(${compare_at_price})`;
      let pCodeInfo = document.getElementById("pCodeInfo");
      pCodeInfo.textContent = `(${product.toUpperCase()})`;
      paymentContainer.style.display = "block";
      // pPayment.style.display = "none";
    }

    setProductInfo();

    function displayProductContainer() {
      // productContainer.style.display = "block";
      // productContainer.scrollIntoView();
    }

    displayProductContainer();
  }

  let textSection = document.querySelector(".p-text-con");
  let installSection = document.querySelector(".install-section-wrapper");

  if (window.innerWidth < 768) {
    textSection.appendChild(installSection);
  }

  // get product info and use it in sticky add to cart
  // when add to cart button not in viewport, display sticky add to cart panel
  // function stickyAddToCart(title, price, compare_at_price, image_url) {
  //   let stickyPanelContainer = document.getElementById("stickyPanelContainer");
  //   let addToCartBtn = document.getElementById("addToCartBtn");
  //   let productTitle = document.getElementById("stickyProductTitle");
  //   productTitle.textContent = title;
  //   let productPrice = document.getElementById("sticky-product-price-after");
  //   productPrice.textContent = price;
  //   let productCompareAtPrice = document.getElementById(
  //     "sticky-product-price-before"
  //   );
  //   productCompareAtPrice.textContent = compare_at_price;
  //   let productImage = document.getElementById("featuredImage");
  //   productImage.src = image_url;
  //   productImage.alt = title;

  //   let sliderSection = document.querySelector(".p-img-slider");

  //   let textSection = document.querySelector(".p-text-con");
  //   let installSection = document.querySelector(".install-section-wrapper");

  //   if (window.innerWidth < 768) {
  //     textSection.appendChild(installSection);
  //   }

  //   document.addEventListener(
  //     "scroll",
  //     () => {
  //       isInViewport(addToCartBtn)
  //         ? (stickyPanelContainer.style.display = "none")
  //         : (stickyPanelContainer.style.display = "block");
  //     },
  //     {
  //       passive: true,
  //     }
  //   );
  // }

  // Converts Number(17999) to String("179.99")
  function fixCurrency(str) {
    var formatliSayi = (str / 100).toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formatliSayi;
  }

  // shows and hide loading icon inside selectboxes
  function loadingIconState(el, status) {
    if (status === "hide") {
      return el.parentElement.classList.contains("is-loading")
        ? el.parentElement.classList.remove("is-loading")
        : null;
    } else {
      return el.parentElement.classList.contains("is-loading")
        ? null
        : el.parentElement.classList.add("is-loading");
    }
  }

  // before displaying new dropdown box, animate previous one
  function animatePreviousBox(el) {
    return el.closest(".column").classList.contains("animate__fadeOutDown")
      ? null
      : el.closest(".column").classList.add("animate__fadeOutDown");
  }

  function enableSelectBox(el) {
    return el.removeAttribute("disabled");
  }

  function disableSelectBox(...args) {
    args.forEach((el) => {
      return el.setAttribute("disabled", "");
    });
  }

  function clearDropdownFields(el) {
    // document.getElementById("dropdownContainer").scrollIntoView();
    // document.getElementById("productContainer").style.display = "none";
    clearOptions(brandSelectBox, "Aracınızın Markasını Seçin", "brand");
    clearOptions(modelSelectBox, "Aracınızın Modelini Seçin", "model");
    clearOptions(yearSelectBox, "Aracınızın Kasasını Seçin", "year");
    clearOptions(engineSelectBox, "Aracınızın Motorunu Seçin", "engine");
    product = "";
    handleBrands(
      `https://service.vitalenoffice.com/service/producttree/getmarkalar`
    );

    let columns = document.querySelectorAll(".selectbox-column");
    columns.forEach((el, index) => {
      if (index == 0) {
        el.classList.remove("is-hidden");
        el.classList.remove("animate__fadeOutDown");
      }
      if (index > 0) {
        el.classList.add("is-hidden");
        el.classList.remove("animate__fadeOutDown");
      }
    });
    resetBreadcrumb();

    if (el.currentTarget.id == "selectAnotherVehicle") {
      let paymentBtnsWrapper = document.querySelector(".payment-btns-wrapper");
      paymentBtnsWrapper.style.display = "none";
      // document.querySelector("#dropdownContainer").scrollIntoView();
      document.querySelector("#productTitle").textContent =
        "Pedal Commander Gaz Tepkime Cihazı";
      document.querySelector("#dropdownContainer").style.display = "flex";
      document.querySelector(".breadcrumbs-section").style.display = "flex";
    }
  }

  function resetBreadcrumb() {
    let breadcrumbItems = document.querySelectorAll(".breadcrumbs-item");
    let stepInfoText = document.querySelector("#stepInfoText");
    stepInfoText.textContent = "Seçiminiz Bekleniyor...";
    breadcrumbItems.forEach((el, index) => {
      switch (index) {
        case 0:
          el.textContent = "Marka?";
          el.parentElement.classList.remove("is-active");
          break;
        case 1:
          el.textContent = "Model?";
          el.parentElement.classList.remove("is-active");
          break;
        case 2:
          el.textContent = "Yıl?";
          el.parentElement.classList.remove("is-active");
          break;
        case 3:
          el.textContent = "Motor?";
          el.parentElement.classList.remove("is-active");
          break;
      }
    });
  }

  function initProductImageSlider() {
    let sliderVid = document.querySelector("#slider-vid");
    let splide = new Splide(".p-img-slider .splide", {
      width: 600,
      height: 360,
      pagination: false,
      cover: true,
      arrows: 0,
    });

    splide.on("move", function () {
      sliderVid.pause();
    });

    let thumbnails = document.getElementsByClassName("thumbnail");
    let current;

    for (let i = 0; i < thumbnails.length; i++) {
      initThumbnail(thumbnails[i], i);
    }

    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener("click", function () {
        splide.go(index);
      });
    }

    splide.on("mounted move", function () {
      var thumbnail = thumbnails[splide.index];

      if (thumbnail) {
        if (current) {
          current.classList.remove("is-active");
        }

        thumbnail.classList.add("is-active");
        current = thumbnail;
      }
    });

    splide.mount();
  }

  initProductImageSlider();

  function updateBreadcrumbs(step, value) {
    let selectionInfo = document.querySelector(
      ".selection-info-container"
    ).children;

    let stepInfoText = document.querySelector("#stepInfoText");

    switch (step) {
      case "brand":
        selectionInfo[0].classList.add("is-active");
        selectionInfo[0].querySelector("span").textContent = value + " \u2713";
        stepInfoText.textContent = "Model Seçiniz";
        break;
      case "model":
        selectionInfo[1].classList.add("is-active");
        selectionInfo[1].querySelector("span").textContent = value + " \u2713";
        stepInfoText.textContent = "Yılı Seçiniz";
        break;
      case "year":
        selectionInfo[2].classList.add("is-active");
        selectionInfo[2].querySelector("span").textContent = value + " \u2713";
        stepInfoText.textContent = "Motoru Seçiniz";
        break;
      case "engine":
        selectionInfo[3].classList.add("is-active");
        selectionInfo[3].querySelector("span").textContent = value + " \u2713";
        stepInfoText.textContent = `${product.toUpperCase()} stokta `;
        break;

      default:
        Array.from(selectionInfo).forEach((el, index) => {
          el.classList.remove("is-active");
        });
    }
  }

  // ########## DO NOT REMOVE THESE COMMENTS | TESTING SCRIPTS
  //  const currentURL = new URL(window.location.href);
  // const make = currentURL.searchParams.get("make");
  // const model = currentURL.searchParams.get("model");
  // const body = currentURL.searchParams.get("variant");
  // const engine = currentURL.searchParams.get("engine");

  // if (make) {
  //   const makeOption = Array.from(brandSelectBox.options).find(
  //     (option) => option.value === make
  //   );
  //   if (makeOption) {
  //     brandSelectBox.value = makeOption.value;
  //     brandSelectBox.dispatchEvent(new Event("change")); // Simulate change event
  //   }
  // }

  // if (model && make) {
  //   const modelOption = Array.from(modelSelectBox.options).find(
  //     (option) => option.value === model
  //   );
  //   if (modelOption) {
  //     modelSelectBox.value = modelOption.value;
  //     modelSelectBox.dispatchEvent(new Event("change")); // Simulate change event
  //   }
  // }

  // if (model && make && body) {
  //   const bodyOption = Array.from(yearSelectBox.options).find(
  //     (option) => option.value === body
  //   );
  //   if (bodyOption) {
  //     yearSelectBox.value = bodyOption.value;
  //     yearSelectBox.dispatchEvent(new Event("change")); // Simulate change event
  //   }
  // }

  // if (model && make && body && engine) {
  //   const engineOption = Array.from(engineSelectBox.options).find(
  //     (option) => option.value === engine
  //   );
  //   if (engineOption) {
  //     engineSelectBox.value = engineOption.value;
  //     engineSelectBox.dispatchEvent(new Event("change")); // Simulate change event
  //   }
  // }
});
